module.exports = __webpack_public_path__ + "static/img/map.663cd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/about/imgs/map.png
// module id = aKrY
// module chunks = 1